export default "__VITE_ASSET__C0khge6H__"